import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=d33ab3fe&scoped=true&"
import script from "./Campus.vue?vue&type=script&lang=js&"
export * from "./Campus.vue?vue&type=script&lang=js&"
import style0 from "./Campus.vue?vue&type=style&index=0&id=d33ab3fe&lang=less&scoped=true&"
import style1 from "./Campus.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33ab3fe",
  null
  
)

export default component.exports